export default __webpack_public_path__ + "static/media/specialMenu.b8473b81.png";